import { OtpInput } from '@aus-platform/design-system';
import classNames from 'classnames';
import { QRCodeSetup } from '../qr-code-setup';

type SetupVerificationProps = {
  className?: string;
  qrCodeUrl: string;
  secretKey: string;
  otpValue: string;
  onOtpChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
};

export const SetupVerification: React.FC<SetupVerificationProps> = ({
  className,
  qrCodeUrl,
  secretKey,
  otpValue,
  onOtpChange,
  disabled = false,
  error,
}) => {
  // Variables.
  const customClassName = classNames('setup-verification', className);

  return (
    <div className={customClassName}>
      <div className="setup-verification__card">
        <QRCodeSetup qrCodeUrl={qrCodeUrl} secretKey={secretKey} />

        <div className="setup-verification__otp-section">
          <div className="setup-verification__otp-description">
            Enter the 6-digit code generated by your authenticator app.
          </div>

          <OtpInput
            cellCount={6}
            allowOnlyNumbers
            value={otpValue}
            onChange={onOtpChange}
            error={error}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};
